"use strict";

// URL L 參數 ↔ sessionStorage.locale（EN / CH）
// 格式：/photo?L=EN（英文）、/photo?L=TW 或不帶參數（中文）
// 舊的 #/photo、?L=EN#/photo 會在 index.html 轉成上面的格式
export function localeToLangParam(locale) {
    return locale === 'EN' ? 'EN' : 'TW';
}

export function langParamToLocale(langParam) {
    var value = (langParam || '').toUpperCase();
    if (value === 'EN') return 'EN';
    if (value === 'TW' || value === 'CH') return 'CH';
    return null;
}

function getQueryValue(queryString, key) {
    if (!queryString) return null;
    var match = queryString.match(new RegExp('(?:^|&)' + key + '=([^&]*)', 'i'));
    return match ? decodeURIComponent(match[1]) : null;
}

function setQueryValue(queryString, key, value) {
    var pairs = [];
    var found = false;
    if (queryString) {
        queryString.split('&').forEach(function(pair) {
            if (!pair) return;
            var parts = pair.split('=');
            var name = parts[0];
            if (name.toLowerCase() === key.toLowerCase()) {
                if (value != null && value !== '') {
                    pairs.push(key + '=' + encodeURIComponent(value));
                }
                found = true;
                return;
            }
            pairs.push(pair);
        });
    }
    if (!found && value != null && value !== '') {
        pairs.push(key + '=' + encodeURIComponent(value));
    }
    return pairs.join('&');
}

export function getUrlLangParam() {
    try {
        var params = new URLSearchParams(window.location.search);
        var fromSearch = params.get('L');
        if (fromSearch) return fromSearch;
    } catch (error) {
        var match = window.location.search.match(/[?&]L=([^&]*)/i);
        if (match) return decodeURIComponent(match[1]);
    }

    // 舊網址尚未轉址前：#/photo?L=EN
    var hash = window.location.hash || '';
    var qIndex = hash.indexOf('?');
    if (qIndex !== -1) {
        return getQueryValue(hash.substring(qIndex + 1), 'L');
    }
    return null;
}

// 進站時依 URL L 寫入語系；有參數以 URL 為準，不帶參數一律中文
export function syncLocaleFromUrl() {
    var localeFromUrl = langParamToLocale(getUrlLangParam());
    var locale = localeFromUrl || 'CH';
    sessionStorage.setItem('locale', locale);
    return locale;
}

export function buildLocaleUrl(pathname, search, locale) {
    var query = (search || '').replace(/^\?/, '');
    var nextQuery = locale === 'EN'
        ? setQueryValue(query, 'L', 'EN')
        : setQueryValue(query, 'L', null);
    var path = pathname || '/';
    return nextQuery ? path + '?' + nextQuery : path;
}

// 語系切換時更新網址：英文 ?L=EN、中文移除 L
export function updateUrlLangParam(locale) {
    var nextUrl = buildLocaleUrl(window.location.pathname, window.location.search, locale);
    window.history.replaceState(null, '', nextUrl);
    return nextUrl;
}

// 站內路徑補上目前語系。英文為 /photo?L=EN，中文不帶 L
export function withLocalePath(path) {
    var raw = path || '';
    if (raw.indexOf('http') === 0) return raw;
    if (raw.charAt(0) === '#') raw = raw.substring(1);

    var qIndex = raw.indexOf('?');
    var pathPart = qIndex === -1 ? raw : raw.substring(0, qIndex);
    var queryPart = qIndex === -1 ? '' : raw.substring(qIndex + 1);
    pathPart = '/' + pathPart.replace(/^\/+/, '');

    var locale = sessionStorage.getItem('locale') || 'CH';
    return buildLocaleUrl(pathPart, queryPart ? '?' + queryPart : '', locale);
}

// 依語系補上場地租借 L 參數（選單僅有單一 linkUrl，無英文專用欄位）
export function resolveMenuLinkUrl(linkUrl) {
    if (!linkUrl || !linkUrl.includes('http')) {
        return linkUrl;
    }

    if (linkUrl.indexOf('rent.pe.ntu.edu.tw') === -1) {
        return linkUrl;
    }

    var locale = sessionStorage.getItem('locale') || 'CH';
    var langParam = localeToLangParam(locale);

    try {
        var url = new URL(linkUrl);
        url.searchParams.set('L', langParam);
        return url.toString();
    } catch (error) {
        if (/[?&]L=/i.test(linkUrl)) {
            return linkUrl.replace(/([?&]L=)[^&]*/i, '$1' + langParam);
        }
        var separator = linkUrl.indexOf('?') !== -1 ? '&' : '?';
        return linkUrl + separator + 'L=' + langParam;
    }
}

export function responseDataGroupByTitle(data, groupBy) {
    var myJSON = {};

    for (var i = 0; i < data.length; i++) {
        var title = data[i][groupBy];
        var row = data[i];

        if (!myJSON[title]) myJSON[title] = [];

        myJSON[title].push(row);
    }
    return myJSON;
}



// WEBPACK FOOTER //
// ./src/assets/library/commonFunction.js